import { useEffect } from 'react';
import './Notifier.scss';

export default function Notifier() {
    return <span className="notifier">!</span>
}